module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    attrs: {
      "epub:type": "frontmatter",
      "id": "rcon",
      "title": "Contents"
    }
  }, [_c('p', {
    staticClass: "h2f"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_vii",
      "title": "vii"
    }
  }, [_vm._v("Contents")])]), _vm._v(" "), _c('p', {
    staticClass: "tocf",
    attrs: {
      "id": "pre"
    }
  }, [_c('span', {
    staticClass: "hide"
  }), _c('a', {
    attrs: {
      "href": "#/text/9780253039538_Preface"
    }
  }, [_vm._v("Preface")])]), _vm._v(" "), _c('p', {
    staticClass: "tocf",
    attrs: {
      "id": "ack"
    }
  }, [_c('span', {
    staticClass: "hide"
  }), _c('a', {
    attrs: {
      "href": "#/text/9780253039538_Acknowledgments"
    }
  }, [_vm._v("Acknowledgments")])]), _vm._v(" "), _c('p', {
    staticClass: "tocf1",
    attrs: {
      "id": "int"
    }
  }, [_c('span', {
    staticClass: "hide"
  }), _c('a', {
    attrs: {
      "href": "#/text/9780253039538_Introduction"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "ch1"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/9780253039538_Chapter_1"
    }
  }, [_c('b', [_vm._v("1")]), _c('span', {
    staticClass: "spacet"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("The Six-Day War and the Emergence of Begin’s Approach to Peace: 1967–70")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "ch2"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780253039538_Chapter_2",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("2")]), _c('span', {
    staticClass: "spacet"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("Return to Opposition: 1970–77")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "ch3"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780253039538_Chapter_3",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("3")]), _c('span', {
    staticClass: "spacet"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("Setting the Stage: May–November 1977")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "ch4"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780253039538_Chapter_4",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("4")]), _c('span', {
    staticClass: "spacet"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("From Jerusalem to Camp David: December 1977–August 1978")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "ch5"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780253039538_Chapter_5",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("5")]), _c('span', {
    staticClass: "spacet"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("Camp David—Between Psychology and Political Realism: September 1978")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "ch6"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780253039538_Chapter_6",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("6")]), _c('span', {
    staticClass: "spacet"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("The Domestic Political Struggle over the Camp David Accords: September 1978")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "ch7"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780253039538_Chapter_7",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("7")]), _c('span', {
    staticClass: "spacet"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("From a Framework to a Peace Treaty: October 1978–March 1979")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "ch8"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780253039538_Chapter_8",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("8")]), _c('span', {
    staticClass: "spacet"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("Implementation: A Glass Half Full")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "ch9"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780253039538_Chapter_9",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("9")]), _c('span', {
    staticClass: "spacet"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("Analysis and Implications")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocf1",
    attrs: {
      "id": "bib"
    }
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/text/9780253039538_Bibliography",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bibliography")])]), _vm._v(" "), _c('p', {
    staticClass: "tocf",
    attrs: {
      "id": "ind"
    }
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/text/9780253039538_Index",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Index")]), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_viii",
      "title": "viii"
    }
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0fd4ed7b","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/9780253039538_Contents.vue
// module id = 75
// module chunks = 0